/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const LOG_BANNER_CODE_TRIED = 'MFE/MBP-CHECKOUT/LOG/BANNER/CODE/TRIED';
export const ATTRIBUTION_APPLY_PROMO_LINKED_PAYMENTMETHOD = 'MFE/MBP-CHECKOUT/ATTRIBUTION/APPLY/PROMO/LINKED/PAYMENTMETHOD';
export const ATTRIBUTION_APPLY_PROMO_LINKED_PAYMENTMETHOD_COMPLETED = 'MFE/MBP-CHECKOUT/ATTRIBUTION/APPLY/PROMO/LINKED/PAYMENTMETHOD/COMPLETED';
export const ATTRIBUTION_APPLY_PROMO = 'MFE/MBP-CHECKOUT/ATTRIBUTION/APPLY/PROMO';
export const ATTRIBUTION_APPLY_PROMO_COMPLETED = 'MFE/MBP-CHECKOUT/ATTRIBUTION/APPLY/PROMO/COMPLETED';

export default {};
